<template>
  <div class="outBox">
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.2)"
           class="mine"></div>
      <div  id="main4" class="chart-container"></div>
    </div>
  </div>

</template>

<script>
import * as echarts from "echarts";



export default {
  name: "echartsFour",
  data(){
    return {
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
      screenWidth: document.documentElement.clientWidth, // 屏幕宽度
    }
  },
  props: ['refundRate'],
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.chart = echarts.init(document.getElementById('main4'));
    this.initBar();
    const _this = this;
    this.$nextTick(function () {
      this.$on('resizeFour', function () {
        _this.chart.resize();
      })
    });
  },
  methods:{
    initBar(){
      let option = {
        backgroundColor: 'transparent',
        series: [
          {
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            center: ['50%', '68%'], // 中心的距离
            radius: '90%',
            min: 0,
            max: 0.1,
            splitNumber: 4,
            axisLine: {
              lineStyle: {
                width: 8,
                color: [
                  [0.25, '#22c55e'],
                  [0.5, '#06b6d4'],
                  [0.75, '#8b5cf6'],
                  [1, '#f97316']
                ],
                shadowColor: 'rgba(15, 23, 42, 0.8)',
                shadowBlur: 8
              }
            },
            pointer: {
              icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
              length: '12%',
              width: 20,
              offsetCenter: [0, '-60%'],
              itemStyle: {
                color: 'auto'
              }
            },
            axisTick: {
              length: 12,
              lineStyle: {
                color: 'auto',
                width: 2
              }
            },
            splitLine: {
              length: 20,
              lineStyle: {
                color: 'auto',
                width: 5
              }
            },
            axisLabel: {
              show: false
            },
            title: {
              // offsetCenter: this.screenWidth < 1600?[0, '-150%'] : [0, '-10%'],
              offsetCenter: [0, '-10%'],
              fontSize: 14,
              color: '#e5f4ff'

            },
            detail: {
              fontSize: 16,
              // offsetCenter: this.screenWidth < 1600?[0, '-120%'] : [0, '-35%'],
              offsetCenter: [0, '-35%'],
              valueAnimation: true,
              formatter: function (value) {
                return (value * 100).toFixed(2) + '%' ;
              },
              color: '#00d4ff'
            },
            data: [
              {
                value: Number(this.refundRate),
                name: '退款率',
              }
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);

    },
  },
  watch: {
    refundRate(newData){
      this.initBar()
    }
  }
}
</script>

<style scoped>
.outBox {
  height: 250px;
}

.box {
  width: 100%;
  height: 250px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}


</style>